// extracted by mini-css-extract-plugin
module.exports = {"lia-date-icon":"OccasionDateIcon_lia-date-icon__wEQBI","lia-month":"OccasionDateIcon_lia-month__8xCTq","lia-date":"OccasionDateIcon_lia-date__4YuXd"};